import { Divider, Typography } from "@mui/material";
import Button from "../../../../input/button";

/**
 * Reusable danger zone section with delete button for block editing
 *
 * @param {Object} props
 * @param {function} props.onDelete - Callback when delete button is clicked
 * @param {string} [props.buttonText="Delete Block"] - Text for the delete button
 * @param {boolean} [props.showDivider=true] - Whether to show divider above
 * @param {boolean} [props.showLabel=true] - Whether to show "Danger Zone" label
 */
const DeleteBlockSection = ({
  onDelete,
  buttonText = "Delete Block",
  showDivider = true,
  showLabel = true,
}) => {
  return (
    <>
      {showDivider && <Divider sx={{ my: 2 }} />}
      {showLabel && (
        <Typography variant="subtitle2" color="text.secondary">
          Danger Zone
        </Typography>
      )}
      <Button
        text={buttonText}
        onClick={onDelete}
        color="red"
        icon="trash"
        fullWidth
      />
    </>
  );
};

export default DeleteBlockSection;
